module.exports = __webpack_public_path__ + "img/rang_bg.30a5ca12.png";